package com.mxpainting.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.mxpainting.Language
import com.mxpainting.LanguageState
import com.mxpainting.rememberLanguage
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.I
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun TopBar() {
    Div(Modifier.fillMaxWidth().classNames("container-fluid", "bg-dark", "text-light", "px-0", "py-2").toAttrs()) {
        Div(Modifier.classNames("row", "gx-0", "d-none", "d-lg-flex").toAttrs()) {
            Div(Modifier.classNames("col-lg-7", "px-5", "text-start").toAttrs()) {
                Div(Modifier.classNames("h-100", "d-inline-flex", "align-items-center", "me-4").toAttrs()) {
                    I(Modifier.classNames("fa", "fa-phone-alt", "text-primary", "me-2").toAttrs()) {}
                    A(href = "tel:2508849487", attrs = Modifier.classNames("text-light", "text-decoration-none").toAttrs()) { Text("+250 884 9487") }
                }
                Div(Modifier.classNames("h-100", "d-inline-flex", "align-items-center").toAttrs()) {
                    I(Modifier.classNames("far", "fa-envelope", "text-primary", "me-2").toAttrs()) {}
                    A(href = "mailto:mxpainting@gmail.com", attrs = Modifier.classNames("text-light", "text-decoration-none").toAttrs()) { Text("mxpainting@gmail.com") }
                }
            }
            Div(Modifier.classNames("col-lg-5", "px-5", "text-end").toAttrs()) {
                Div(Modifier.classNames("h-100", "d-inline-flex", "align-items-center", "mx-n2").toAttrs()) {
                    val language by rememberLanguage()
                    
                    Span(Modifier.classNames("me-3").toAttrs()) { Text("Victoria, BC") }
                    
                    // Language Toggle
                    Div(Modifier.classNames("mx-2", "d-flex", "align-items-center").onClick {
                        LanguageState.setLanguage(if (language == Language.ENGLISH) Language.SPANISH else Language.ENGLISH)
                    }.toAttrs()) {
                        Img(
                            src = if (language == Language.ENGLISH) "/img/flag_mx.png" else "/img/flag_ca.png",
                            alt = if (language == Language.ENGLISH) "Switch to Spanish" else "Switch to English",
                            attrs = Modifier.width(28.px).height(28.px).borderRadius(50.percent).toAttrs()
                        )
                    }

                    A(href = "https://www.facebook.com/MX-Painting-931817703684196/", attrs = Modifier.classNames("btn", "btn-link", "text-light").toAttrs()) {
                        I(Modifier.classNames("fab", "fa-facebook-f").toAttrs()) {}
                    }
                    A(href = "https://www.instagram.com/mxpainting/", attrs = Modifier.classNames("btn", "btn-link", "text-light").toAttrs()) {
                        I(Modifier.classNames("fab", "fa-instagram").toAttrs()) {}
                    }
                }
            }
        }
    }
}
